import react, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faRightToBracket,
  faUserPlus,
} from "@fortawesome/free-solid-svg-icons";
import Modal from "../components/Modal";
import Register from "../components/register";
import Login from "../components/login";
import Swal from "sweetalert2";

export default function Header() {
  const history = useHistory();
  const isAuthenticated = !!localStorage.getItem("userToken");
  const [isRegModalOpen, setIsRegModalOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleLogout = (e) => {
    e.preventDefault();
    Swal.fire({
      title: "Are you sure you want to logout?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, logout",
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem("userToken");
        localStorage.clear();
        Swal.fire({
          title: "Logged Out!",
          text: "You have been successfully logged out.",
          icon: "success",
          confirmButtonColor: "#3085d6",
        }).then(() => {
          //  window.location.to = "/";
          history.push("/");
        });
      }
    });
  };
   const userId = localStorage.getItem("currentUserId");
    const cartKey = `cart_${userId}`;
  const cart_detail = JSON.parse(localStorage.getItem(cartKey) || "[]");
   const [menuOpen, setMenuOpen] = useState(false);


  const toggleMenu = () => setMenuOpen(!menuOpen);
  return (
    // <header className="th-header header-layout8">
    //   <div className="header-top">
    //     <div className="container">
    //       <div className="row gy-2 justify-content-center justify-content-lg-between align-items-center">
    //         <div className="col-auto">
    //           <div className="header-links">
    //             <ul>
    //               <li>
    //                 <i className="fa-solid fa-envelope"></i>
    //                 <Link to="mailto:info@shreejimeditechsystems.com">
    //                  info@shreejimeditechsystems.com
    //                 </Link>
    //               </li>
    //               <li className="d-none d-md-inline-block">
    //                 <i className="fa-solid fa-location-dot"></i>
    //                 <span>Sardar Patel Ringroad, Zundal, Ahmedabad</span>
    //               </li>
    //             </ul>
    //           </div>
    //         </div>
    //         <div className="col-auto">
    //           <div className="header-button">
    //             <Link to="/contact" className="th-btn style4">
    //               <img src="assets/img/icon/alarm.svg" alt="" />
    //               24 Hour Emergency Aid
    //             </Link>
    //             <form className="search-form">
    //               <input type="text" placeholder="Search..." />
    //               <button type="submit">
    //                 <i className="fa-light fa-magnifying-glass"></i>
    //               </button>
    //             </form>
    //             <Link  to="/cart" className="cart-btn sideMenuToggler2">
    //               Cart <i className="fa-solid fa-cart-shopping"></i>
    //               <span className="badge">{cart_detail.length}</span>
    //             </Link>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    //   <div className="sticky-wrapper">
    //     {/* <!-- Main Menu Area --> */}
    //     <div className="container">
    //       <div className="menu-area">
    //         <div className="row align-items-center justify-content-between">
    //           <div className="col-auto">
    //             <div className="header-logo">
    //               <Link to="/">
    //                 <img src="assets/img/medical-logo.svg" alt="shreeji" />
    //               </Link>
    //             </div>
    //           </div>
    //           <div className="col-auto">
    //             <nav className="main-menu style2 d-none d-lg-inline-block">
    //               <ul>
    //                 <li>
    //                   <Link to="/">Home</Link>
    //                 </li>
    //                 <li>
    //                   <Link to="/about">About Us</Link>
    //                 </li>
    //                 <li>
    //                   <Link to="/shop">Products</Link>
    //                 </li>

    //                 <li>
    //                   <Link to="/contact">Contact</Link>
    //                 </li>
    //               </ul>
    //             </nav>
                
    //             <div className="header-button">
    //               <button
    //                 type="button"
    //                 className="th-menu-toggle d-inline-block d-lg-none"
    //               >
    //                 <i className="far fa-bars"></i>
    //               </button>
    //             </div>
    //           </div>
              
    //           <div className="col-auto d-none d-xl-block">
    //             <div className="header-button">
    //             {!isAuthenticated ? (
    //               <>
    //                 <Link
    //                   to="#"
    //                   className="cart-btn sideMenuToggler2"
    //                   onClick={() => setIsModalOpen(true)}
    //                 >
    //                   Login <FontAwesomeIcon icon={faRightToBracket} />
    //                 </Link>
    //                 <Modal
    //                   isOpen={isModalOpen}
    //                   onClose={() => setIsModalOpen(false)}
    //                   title="Login"
    //                 >
    //                   <Login onClose={() => setIsModalOpen(false)} />
    //                 </Modal>
    //                 <Link
    //                   to="#"
    //                   className="cart-btn sideMenuToggler2"
    //                   onClick={() => setIsRegModalOpen(true)}
    //                 >
    //                   Register
    //                   <FontAwesomeIcon icon={faUserPlus} />
    //                 </Link>
    //                 <Modal
    //                   isOpen={isRegModalOpen}
    //                   onClose={() => setIsRegModalOpen(false)}
    //                   title="Register"
    //                 >
    //                   <Register onClose={() => setIsRegModalOpen(false)} />
    //                 </Modal>
    //                 <Link to="/cart" className="cart-btn sideMenuToggler2">
    //                   Cart <i className="fa-solid fa-cart-shopping"></i>
    //                 </Link>
    //               </>
    //             ) : (
    //               <>
    //                 <Link to="#" className="cart-btn" onClick={handleLogout}>
    //                   Logout
    //                 </Link>
    //               </>
    //             )}
                
    //               <Link to="/contact" className="th-btn style5">
    //                 Make Appointment{" "}
    //                 <i className="fa-solid fa-calendar-days ms-2"></i>
    //               </Link>
    //             </div>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </header>
     <header className="th-header header-layout8">
      {/* --- Top Header --- */}
      <div className="header-top">
        <div className="container">
          <div className="row gy-2 justify-content-center justify-content-lg-between align-items-center">
            <div className="col-auto">
              <div className="header-links">
                <ul>
                  <li>
                    <i className="fa-solid fa-envelope"></i>
                    <Link to="mailto:info@shreejimeditechsystems.com">
                     info@shreejimeditechsystems.com
                    </Link>
                  </li>
                <li className="d-none d-md-inline-block">
                   <span>Sardar Patel Ringroad, Zundal, Ahmedabad</span>
                   </li>
                </ul>
             </div>
            </div>
             <div className="col-auto">
              <div className="header-button">
                 <Link to="/contact" className="th-btn style4">
                   <img src="assets/img/icon/alarm.svg" alt="" />
                   24 Hour Emergency Aid
                </Link>
                <form className="search-form">
                  <input type="text" placeholder="Search..." />
                  <button type="submit">
                     <i className="fa-light fa-magnifying-glass"></i>
                  </button>
                </form>
                 <Link  to="/cart" className="cart-btn sideMenuToggler2">
                  Cart <i className="fa-solid fa-cart-shopping"></i>
                   <span className="badge">{cart_detail.length}</span>
                </Link>
                  {!isAuthenticated ? (
                  <>
                    <Link
                      to="#"
                      className="cart-btn sideMenuToggler2"
                      onClick={() => setIsModalOpen(true)}
                    >
                      Login <FontAwesomeIcon icon={faRightToBracket} />
                    </Link>
                    <Modal
                      isOpen={isModalOpen}
                      onClose={() => setIsModalOpen(false)}
                      title="Login"
                    >
                      <Login onClose={() => setIsModalOpen(false)} />
                    </Modal>
                    <Link
                      to="#"
                      className="cart-btn sideMenuToggler2"
                      onClick={() => setIsRegModalOpen(true)}
                    >
                      Register
                      <FontAwesomeIcon icon={faUserPlus} />
                    </Link>
                    <Modal
                      isOpen={isRegModalOpen}
                      onClose={() => setIsRegModalOpen(false)}
                      title="Register"
                    >
                      <Register onClose={() => setIsRegModalOpen(false)} />
                    </Modal>
                  </>
                ) : (
                  <>
                    <Link to="#" className="cart-btn" onClick={handleLogout}>
                      Logout
                    </Link>
                  </>
                )}
               </div>
             </div>
          </div>
        </div>
      </div>

      {/* --- Main Header --- */}
      <div className="sticky-wrapper">
        <div className="container">
          <div className="menu-area d-flex justify-content-between align-items-center">
            <div className="header-logo">
              <Link to="/">
                <img src="assets/img/medical-logo.svg" alt="shreeji" />
              </Link>
            </div>

            {/* Desktop Menu */}
            <nav className="main-menu d-none d-lg-block">
              <ul>
                <li><Link to="/">Home</Link></li>
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/shop">Products</Link></li>
                <li><Link to="/contact">Contact</Link></li>
              </ul>
            </nav>

            {/* Mobile Toggle Button */}
            <button className="th-menu-toggle d-lg-none" onClick={toggleMenu}>
              <i className="far fa-bars"></i>
            </button>

            {/* Appointment Button */}
            <div className="d-none d-xl-flex header-button">
              <Link to="/contact" className="th-btn style5">
                Make Appointment <i className="fa-solid fa-calendar-days ms-2"></i>
              </Link>
            </div>
          </div>
        </div>

        {/* --- Mobile Menu --- */}
        {menuOpen && (
          <div className="mobile-menu">
            <ul>
              <li><Link to="/" onClick={toggleMenu}>Home</Link></li>
              <li><Link to="/about" onClick={toggleMenu}>About Us</Link></li>
              <li><Link to="/shop" onClick={toggleMenu}>Products</Link></li>
              <li><Link to="/contact" onClick={toggleMenu}>Contact</Link></li>
            </ul>
          </div>
        )}
      </div>
    </header>
  );
}
